import {nombreZonaEnPlano,pisoZonaNombre} from '../../utils/presentacionZona';
import {permiteRol,puedeOperarReserva} from '../../utils/permisosRol';
import {paqueteParaZona} from '../../utils/aplicacionPaquetes';
import {catalogoComercial} from '../../utils/comercialEvento';
import MapaReservaInteractivo from '../../components/recintos/MapaReservaInteractivo';
import {zonasDeEscena} from '../../utils/planimetria';
import {obtenerUsuariosDelAlcance} from '../../utils/eventAccess';
import {puedeAccederEvento} from '../../utils/accessPolicy';
import { normalizarRol } from '../../utils/roles';
import { leerUsuario } from '../../utils/legacyData';
import { escucharReservasPrivadas, nuevaSolicitudReserva } from '../../utils/reservasPrivadas';
import { titularReserva } from '../../utils/reservasPolicy';
import { persistirReserva, cargarEntregaReserva } from '../../utils/reservasService';
import { cantidadPaquete } from '../../utils/prepagoContrato';
import { obtenerRelacionadoresEvento } from '../../utils/relacionadores';
import { resolverAtribucion, nombreAtribuido, snapshotCreador, normalizarUsuarioOperativo } from '../../utils/identidadOperativa';
// src/pages/reservas/Reservas.jsx
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import zonasBase from '../../data/zonas';
import './Reservas.css';

import MapaReservas from './components/MapaReservas';
import WizardReserva from './components/WizardReserva';
import ModalPrepago from './components/ModalPrepago';
import ModalEntrega from './components/ModalEntrega';
import GestionReserva from './components/GestionReserva';

import { useAuth } from '../../context/AuthContext';

import { db } from '../../firebase/firebaseConfig';
import { doc } from 'firebase/firestore';
import { getDoc } from '../../utils/firestoreRead';

import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { compartirArchivosEntradasReserva } from '../../utils/compartirEntradasReserva';

import { getAuth, onAuthStateChanged } from 'firebase/auth';

const ESTADOS = {
  DISPONIBLE: 'disponible',
  RESERVADA: 'reservada',
  PREPAGADA: 'prepagada',
};

const MESA_SIZE = 40;
const OFFSET_X = -11;
const OFFSET_Y = -70;

const MAP_BASE_WIDTH = 720;
const MAP_BASE_HEIGHT = 1120;

const colorPorEstado = (estado) => {
  switch (estado) {
    case ESTADOS.RESERVADA:
      return '#ffff00';
    case ESTADOS.PREPAGADA:
      return '#ff0000';
    default:
      return '#00ff00';
  }
};

function inferPiso(zona) {
  const id = (zona.label || zona.id || '').toUpperCase();
  if (id.startsWith('2P-')) return '2P';
  return '1P';
}

function esMesa(zona) {
  const texto = (zona.label || zona.id || '').toLowerCase();
  return texto.includes('mesa');
}

function esLounge(zona) {
  const txt = (zona.label || zona.id || '').toUpperCase();
  return (
    txt.startsWith('LOUNGE') ||
    txt.startsWith('2P-LOUNGE') ||
    txt.startsWith('2P-PALCO') ||
    txt.includes('PALCO') ||
    txt.includes('SUPER VIP')
  );
}

function tipoZonaTexto(zona) {
  if(zona?.tipoZona)return zona.tipoZona.toLowerCase().replace('_',' ');
  if (!zona) return 'zona';
  const id = (zona.label || zona.id || '').toUpperCase();
  if (id.includes('MESA')) return 'mesa';
  if (id.includes('LOUNGE')) return 'lounge';
  if (id.includes('PALCO')) return 'palco';
  if (id.includes('SUPER')) return 'super vip';
  return esLounge(zona) ? 'lounge' : 'mesa';
}

function prepararZonasProcesadas() {
  const todas = zonasBase || [];

  const mesas = todas
    .filter(esMesa)
    .map((z) => {
      const match = (z.label || '').match(/(\d+)/);
      const num = match ? parseInt(match[1], 10) : NaN;
      return { ...z, _num: isNaN(num) ? null : num };
    })
    .filter((z) => z._num != null)
    .sort((a, b) => a._num - b._num);

  if (mesas.length === 0) return todas;

  const mesa1 = mesas.find((m) => m._num === 1) || mesas[0];
  const mesa2 = mesas.find((m) => m._num === 2) || mesas[1] || mesas[0];

  const impares = mesas.filter((m) => m._num % 2 === 1);
  const baseY = impares[0]?.y || mesa1.y || 0;

  const diffs = [];
  for (let i = 1; i < impares.length; i++) {
    const d = impares[i].y - impares[i - 1].y;
    if (d > 0) diffs.push(d);
  }

  const pasoY =
    diffs.length > 0 ? diffs.reduce((a, b) => a + b, 0) / diffs.length : 45;

  const colX = [mesa1.x ?? 0, mesa2.x ?? (mesa1.x ?? 0) + 80];

  const layoutMesas = {};
  mesas.forEach((m) => {
    const num = m._num;
    const col = num % 2 === 1 ? 0 : 1;
    const fila = Math.floor((num - 1) / 2);

    layoutMesas[m.id] = {
      x: colX[col],
      y: baseY + fila * pasoY,
      width: MESA_SIZE,
      height: MESA_SIZE,
    };
  });

  return todas.map((z) => {
    const override = layoutMesas[z.id];
    return override ? { ...z, ...override } : { ...z };
  });
}

const zonasProcesadasBase = prepararZonasProcesadas();

function numeroVisible(zona) {
  const fuente = (nombreZonaEnPlano(zona) || zona.id || '').toString();
  const match = fuente.match(/(\d+)/g);
  if (match && match.length > 0) return match[match.length - 1];
  return fuente || zona.id || '?';
}



function tieneNombreApellido(s) {
  const clean = (s || '').trim().replace(/\s+/g, ' ');
  return clean.split(' ').filter(Boolean).length >= 2;
}



function tipoAplicacionId(zona) {
  const t = tipoZonaTexto(zona);
  if (!t) return 'LOUNGE';
  const x = t.toString().trim().toLowerCase();
  if (x === 'sector') return 'SECTOR';
  if (x === 'asiento') return 'ASIENTO';
  if (x === 'mesa') return 'MESA';
  if (x === 'palco') return 'PALCO';
  if (x === 'super vip') return 'SUPER_VIP';
  return 'LOUNGE';
}

function normalizarZonaId(v) {
  return (v || '')
    .toString()
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/-/g, '');
}

function buildZonasBase() {
  return (zonasProcesadasBase || []).map((z) => ({
    ...z,
    piso: inferPiso(z),
    estado: ESTADOS.DISPONIBLE,
    nombreCliente: '',
    atribuidoANombre: '',
    atribuidoAUid: '',
    paqueteId: '',
    paqueteNombre: '',
    precioPaqueteCentavos: 0,
  }));
}

function Reservas() {
  const navigate = useNavigate();
  const { eventoId } = useParams();

  const auth = getAuth();
  const { usuario,profile:perfilContexto } = useAuth();

  const uidContext = usuario?.uid || usuario?.id || '';
  const nombreUsuario = (usuario?.nombre || '').toString().trim();

  const [uidEfectivo, setUidEfectivo] = useState(uidContext);
  const [rolEfectivo, setRolEfectivo] = useState('');
  const perfilEfectivo=perfilContexto||{rol:rolEfectivo};
  const puedeElegirRelacionador = rolEfectivo === 'owner';

  // ✅ El evento SIEMPRE viene por ruta
  const [eventoActual, setEventoActual] = useState(null);

  const [paquetesEvento, setPaquetesEvento] = useState([]);
  const [loadingPaquetes, setLoadingPaquetes] = useState(false);
  const [errorPaquetes, setErrorPaquetes] = useState('');

  const [zonas, setZonas] = useState(() => buildZonasBase());
  const [zonaActiva, setZonaActiva] = useState(null);

  const [wizardOpen, setWizardOpen] = useState(false);
  const [paso, setPaso] = useState(1);
  const [error, setError] = useState('');

  const [modalCompraOpen, setModalCompraOpen] = useState(false);

  const [titularesOperativos,setTitularesOperativos]=useState([]);
  const [listaReservadores, setListaReservadores] = useState([]);
  const [cargandoReservadores, setCargandoReservadores] = useState(false);

  const [atribucionPropiaUid, setAtribucionPropiaUid] = useState('');
  const [atribucionPropiaNombre, setAtribucionPropiaNombre] = useState('');

  const [form, setForm] = useState({
    nombreCliente: '',
    atribuidoAUid: '',
    atribuidoANombre: '',
    quierePrepagar: false,
    paqueteId: '',
  });

  const [disponibilidadLista, setDisponibilidadLista] = useState(false);
  const [gestion, setGestion] = useState(null);
  const [planoRecinto,setPlanoRecinto]=useState(null);
  const [mapaCargadoPara,setMapaCargadoPara]=useState(null);
  const [errorMapa,setErrorMapa]=useState(false);
  const contextoCargaMapa=JSON.stringify([eventoId,rolEfectivo,uidEfectivo,perfilContexto?.activo,perfilContexto?.empresaId,perfilContexto?.empresasPermitidas,perfilContexto?.eventosPermitidos,perfilContexto?.eventosBloqueados,perfilContexto?.politicaRol]);
  const [contextoRecinto,setContextoRecinto]=useState(null);
  const [aplicacionesPaquetes,setAplicacionesPaquetes]=useState({});
  const [revisionMapa, setRevisionMapa] = useState(0);
  const solicitudGuardado = useRef(null);
  const [entrega, setEntrega] = useState(null);
  const [compartiendoEntradas, setCompartiendoEntradas] = useState(false);
  const generandoEntrega = false;
  const [guardandoReserva, setGuardandoReserva] = useState(false);

  const [mapScale, setMapScale] = useState(1);

  // ✅ NUEVO: carrito de combos/entradas extra
  const [carritoEntradas, setCarritoEntradas] = useState({});

  const [relojComercial,setRelojComercial]=useState(Date.now());
  useEffect(()=>{const t=setInterval(()=>setRelojComercial(Date.now()),15000);return()=>clearInterval(t);},[]);
  const catalogoVenta=useMemo(()=>catalogoComercial(eventoActual,paquetesEvento.map(p=>aplicacionesPaquetes[p.id]?{...p,aplicacionRecinto:aplicacionesPaquetes[p.id]}:p),relojComercial),[eventoActual,paquetesEvento,relojComercial,aplicacionesPaquetes]);
  const opcionesPago = useMemo(() => {
    if (!zonaActiva) return [];
    const tipoId = tipoAplicacionId(zonaActiva);
    const list = catalogoVenta.paquetes;
    return list
      .filter((p) => { try { cantidadPaquete(p); return true; } catch { return false; } })
      .filter((p) => (typeof p.activo === 'boolean' ? p.activo : true))
      .filter((p) => paqueteParaZona(p,tipoId,zonaActiva.id,contextoRecinto))
      .map((p) => ({
        id: p.id,
        nombre: p.nombre || 'Paquete',
        precioCentavos: Number(p.precioCentavos || 0),
        incluye: p.incluye,
        consumoCentavos: p.consumoCentavos,
        cantidadEntradas: cantidadPaquete(p),
      }));
  }, [zonaActiva, catalogoVenta,contextoRecinto]);

  // ✅ NUEVO: combos desde el evento (misma lógica que tu módulo Entradas)
  const combosEntradas = useMemo(() => {
    const combos = catalogoVenta.evento?.combos;
    if (!Array.isArray(combos) || combos.length === 0) return [];
    return combos.map((c, idx) => ({
      id: c.id || `combo-${idx}`,
      nombre: String(c.nombre || `Combo ${idx + 1}`),
      precioCentavos: Number(c.precioCentavos || 0),
      cantidadEntradas: Number(c.cantidadEntradas || 1),
      incluye: c.incluye || [],
    }));
  }, [catalogoVenta]);

  const totalExtras = useMemo(() => {
    let total = 0;
    const map = carritoEntradas || {};
    for (const c of combosEntradas) {
      const qty = Number(map[c.id] || 0);
      if (qty > 0) total += qty * Number(c.precioCentavos || 0);
    }
    return total;
  }, [carritoEntradas, combosEntradas]);

  const totalGeneral = useMemo(() => {
    const paquete = opcionesPago.find((o) => o.id === form.paqueteId);
    const totalPaquete = paquete ? Number(paquete.precioCentavos || 0) : 0;
    return totalPaquete + Number(totalExtras || 0);
  }, [form.paqueteId, opcionesPago, totalExtras]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u?.uid) setUidEfectivo(u.uid);
      else if (uidContext) setUidEfectivo(uidContext);
    });
    return () => unsub();
  }, [auth, uidContext]);

  useEffect(() => {
    const run = async () => {
      try {
        if (!uidEfectivo) return;

        const ref = doc(db, 'usuarios', uidEfectivo);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          const data = snap.data() || {};
          const r = normalizarRol(leerUsuario(data, uidEfectivo)?.rol || '');
          setRolEfectivo(r);
        } else {
          setRolEfectivo(normalizarRol(usuario?.rol || ''));
        }
      } catch (e) {
        console.error('No se pudo leer rol en usuarios/:uid', e);
        setRolEfectivo(normalizarRol(usuario?.rol || ''));
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uidEfectivo]);

  // ✅ Guard: si intentan abrir Reservas sin :eventoId, vuelve al selector
  useEffect(() => {
    if (!eventoId) {
      navigate('/dashboard/reservas', { replace: true });
    }
  }, [eventoId, navigate]);

  // ========= Cargar paquetes del evento =========
  useEffect(() => {
    const cargarPaquetesDeEvento = async () => {
      setErrorPaquetes('');
      setPaquetesEvento([]);
      setEventoActual(null);

      if (!eventoId) return;

      setLoadingPaquetes(true);
      try {
        const evSnap = await getDoc(doc(db, 'eventos', eventoId));
        if (!evSnap.exists()) {
          setErrorPaquetes('El evento seleccionado no existe.');
          return;
        }

        const ev = { id: eventoId, ...evSnap.data() };
        setEventoActual(ev);

        const listaId = ev.listaReservaId || '';
        if (!listaId) {
          setErrorPaquetes('Este evento no tiene una lista de paquetes asignada.');
          return;
        }

        const listaSnap = await getDoc(doc(db, 'listasReserva', listaId));
        if (!listaSnap.exists()) {
          setErrorPaquetes('La lista asignada al evento no existe.');
          return;
        }

        const lista = listaSnap.data() || {};
        if (lista.activo === false) { setErrorPaquetes('La lista asignada está inactiva.'); return; }
        const ids = Array.isArray(lista.paquetes) ? lista.paquetes : [];
        if (ids.length === 0) {
          setErrorPaquetes('La lista asignada no tiene paquetes.');
          return;
        }

        const docsPaquetes = await Promise.all(
          ids.map(async (pid) => {
            try {
              const ps = await getDoc(doc(db, 'paquetesReserva', pid));
              return ps.exists() ? { id: pid, ...ps.data() } : null;
            } catch {
              return null;
            }
          })
        );

        setPaquetesEvento(docsPaquetes.filter(Boolean));
      } catch (e) {
        console.error('Error cargando paquetes del evento:', e);
        setErrorPaquetes('No se pudieron cargar los paquetes del evento.');
      } finally {
        setLoadingPaquetes(false);
      }
    };

    cargarPaquetesDeEvento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventoId]);

  useEffect(()=>{setEntrega(null);setGestion(null);setZonaActiva(null);setWizardOpen(false);setModalCompraOpen(false);},[eventoId,rolEfectivo,uidEfectivo]);
  // Disponibilidad mínima y datos privados; refresco inmediato después de mutaciones.
  useEffect(() => {
    setDisponibilidadLista(false);
    setErrorMapa(false);
    if (!eventoId) {
      setZonas(buildZonasBase());
      return;
    }

    if (!rolEfectivo || !uidEfectivo) return undefined;
    setDisponibilidadLista(false);

    const unsub = escucharReservasPrivadas(
      eventoId, rolEfectivo,
      ({ reservas, ocupacion,plano,contextoRecinto,aplicacionesPaquetes }) => {
        setMapaCargadoPara(contextoCargaMapa);
        setErrorMapa(false);
        setContextoRecinto(contextoRecinto||null);
        setAplicacionesPaquetes(aplicacionesPaquetes||{});
        setPlanoRecinto(actual => {
          const siguiente = plano || null;
          return JSON.stringify(actual) === JSON.stringify(siguiente) ? actual : siguiente;
        });
        setGestion(prev=>prev&&reservas.some(r=>r.id===prev.reserva.id&&['reservada','prepagada'].includes(r.estado))?prev:null);
        setEntrega(prev => prev && reservas.some(r => r.id === prev.reserva?.id && ['reservada','prepagada'].includes(r.estado)) ? prev : null);
        const ocupadas = new Map(ocupacion.filter(r => ['reservada','prepagada'].includes(r.estado)).map(r => [normalizarZonaId(r.zonaId), r]));
        setDisponibilidadLista(true);

        const byZona = new Map();
        for (const r of reservas.filter(r=>['reservada','prepagada'].includes(r.estado))) {
          const zonaKey = normalizarZonaId(r.zonaId);
          if (!zonaKey) continue;

          const curr = byZona.get(zonaKey);
          if (!curr) {
            byZona.set(zonaKey, r);
            continue;
          }

          const tA = r.updatedAt?.toMillis?.() || r.createdAt?.toMillis?.() || 0;
          const tB = curr.updatedAt?.toMillis?.() || curr.createdAt?.toMillis?.() || 0;
          if (tA >= tB) byZona.set(zonaKey, r);
        }

        const base = plano ? zonasDeEscena(plano) : buildZonasBase();

        setZonas(
          base.map((z) => {
            const r = byZona.get(normalizarZonaId(z.id));
            if (!r) return ocupadas.has(normalizarZonaId(z.id)) ? { ...z, estado: ocupadas.get(normalizarZonaId(z.id)).estado, bloqueada: ocupadas.get(normalizarZonaId(z.id)).estado !== 'reservada', reservaPublica: {id:ocupadas.get(normalizarZonaId(z.id)).reservaId,estado:'reservada'} } : z;

            const estado = (r.estado || '').toString().toLowerCase();
            const estadoFinal =
              estado === 'prepagada'
                ? ESTADOS.PREPAGADA
                : estado === 'reservada'
                ? ESTADOS.RESERVADA
                : ESTADOS.DISPONIBLE;

            return {
              ...z,
              reserva: r,
              estado: estadoFinal,
              nombreCliente: r.nombreCliente || '',
              atribuidoANombre: nombreAtribuido(r),
              atribuidoAUid: r.atribuidoAUid || '',
              paqueteId: r.paqueteId || '',
              paqueteNombre: r.paqueteNombre || '',
              precioPaqueteCentavos: Number(r.montoCentavos || 0),
            };
          })
        );
      },
      (err) => {
        console.error('Error escuchando reservas:', err);
        setErrorMapa(true);
        setDisponibilidadLista(false); setError('No se pudo verificar la disponibilidad. Actualiza antes de reservar.');
      }
    );

    return () => unsub();
  }, [eventoId, rolEfectivo, uidEfectivo, revisionMapa,contextoCargaMapa]);

  // ========= Reservadores (owner/socio) =========
  useEffect(() => {
    if (!eventoActual) return;

    let mounted = true;
    (async () => {
      try {
        setCargandoReservadores(true);
        const lista = await obtenerRelacionadoresEvento(eventoActual, 'reservas');
        if (!mounted) return;
        setListaReservadores(lista || []);
        if(permiteRol(perfilEfectivo,'reservas.modificar')){const usuarios=await obtenerUsuariosDelAlcance();if(!mounted)return;setTitularesOperativos(usuarios.map(p=>normalizarUsuarioOperativo(p)).filter(p=>p&&puedeAccederEvento(p.perfil,eventoActual,'reservas')));}else setTitularesOperativos([]);

        const yo = (lista || []).find((p) => p.id === uidEfectivo);
        if (yo) {
          setAtribucionPropiaUid(yo.id);
          setAtribucionPropiaNombre(yo.nombre);
        } else {
          setAtribucionPropiaUid('');
          setAtribucionPropiaNombre('');
        }
      } catch (e) {
        console.error('Error cargando RRPP/Imagen:', e);
        if (!mounted) return;
        setListaReservadores([]);
        setAtribucionPropiaUid('');
        setAtribucionPropiaNombre('');
      } finally {
        if (mounted) setCargandoReservadores(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [eventoActual, uidEfectivo,rolEfectivo]);

  useEffect(() => {
    const calcularScale = () => {
      const viewportWidth = window.innerWidth || MAP_BASE_WIDTH;
      const margenHorizontal = 32;
      const maxWidthDisponible = viewportWidth - margenHorizontal;

      if (maxWidthDisponible <= 0) return 1;

      const escala =
        maxWidthDisponible < MAP_BASE_WIDTH ? maxWidthDisponible / MAP_BASE_WIDTH : 1;

      return escala < 0.4 ? 0.4 : escala;
    };

    const actualizarScale = () => setMapScale(calcularScale());
    actualizarScale();
    window.addEventListener('resize', actualizarScale);
    return () => window.removeEventListener('resize', actualizarScale);
  }, []);

  // ========= Helpers de UI =========
  const cerrarWizard = () => {
    setWizardOpen(false);
    setZonaActiva(null);
    setPaso(1);
    setError('');
  };

  const abrirModalCompra = () => {
    setError('');
    setModalCompraOpen(true);
  };

  const cerrarModalCompra = () => {
    setModalCompraOpen(false);
    setZonaActiva(null);
    setWizardOpen(false);
    setPaso(1);
    setError('');
    setCarritoEntradas({}); // ✅ limpiar carrito
  };

  const tituloZona = zonaActiva
    ? `${tipoZonaTexto(zonaActiva).toUpperCase()} ${numeroVisible(zonaActiva)}`
    : '';

  const pisoZona = pisoZonaNombre(zonaActiva);

  const aplicarReservaEnMapa = (quierePrepagar, paqueteId, atribucion) => {
    if (!zonaActiva) return null;

    const nombreCliente = (form.nombreCliente || '').trim().replace(/\s+/g, ' ');
    const estadoFinal = quierePrepagar ? ESTADOS.PREPAGADA : ESTADOS.RESERVADA;

    const paqueteSeleccionado = quierePrepagar
      ? (opcionesPago || []).find((o) => o.id === paqueteId) || null
      : null;

    const { atribuidoAUid, atribuidoANombre } = atribucion;

    setZonas((prev) =>
      (prev || []).map((z) =>
        z.id === zonaActiva.id
          ? {
              ...z,
              estado: estadoFinal,
              nombreCliente,
              atribuidoANombre,
              atribuidoAUid,
              paqueteId: paqueteSeleccionado ? paqueteSeleccionado.id : '',
              paqueteNombre: paqueteSeleccionado ? paqueteSeleccionado.nombre : '',
              precioPaqueteCentavos: paqueteSeleccionado ? paqueteSeleccionado.precioCentavos : 0,
            }
          : z
      )
    );

    return { nombreCliente, estadoFinal, atribuidoAUid, atribuidoANombre, paqueteSeleccionado };
  };

  const crearReservaFirestore = async ({ estado }) => {
    const existente = zonaActiva?.reserva || zonaActiva?.reservaPublica;
    const atribucion = (existente?.atribuidoAUid !== undefined ? existente : null) || resolverAtribucion(await obtenerRelacionadoresEvento(eventoActual, 'reservas'),
      puedeElegirRelacionador ? form.atribuidoAUid || atribucionPropiaUid : '', eventoActual, 'reservas',
      { requerida: false, uid: uidEfectivo, rol: rolEfectivo });
    const base = {
      eventoId, eventoNombre: eventoActual?.nombre || '', eventoFecha: eventoActual?.fechaTexto || '',
      empresaId: eventoActual?.empresaId, empresaNombre: eventoActual?.empresaNombre || '',
      zonaId: zonaActiva.id, zonaNombre: tituloZona, piso: pisoZona, tipoZona: tipoAplicacionId(zonaActiva),
      nombreCliente: form.nombreCliente.trim().replace(/\s+/g, ' '),
      atribuidoAUid: atribucion.atribuidoAUid, atribuidoANombre: atribucion.atribuidoANombre,
      atribuidoARol: atribucion.atribuidoARol,
      ...snapshotCreador({ nombre: nombreUsuario || usuario?.email || '', rol: rolEfectivo }, uidEfectivo),
    };
    const datos = {base,reservaExistenteId:existente?.id||null,paqueteId:estado===ESTADOS.PREPAGADA?form.paqueteId:null,carrito:carritoEntradas,
      ...(estado===ESTADOS.PREPAGADA?{importeEsperadoCentavos:totalGeneral}:{})};
    const key=JSON.stringify(datos);if(solicitudGuardado.current?.key!==key)solicitudGuardado.current={key,id:nuevaSolicitudReserva()};
    const resultado=await persistirReserva({...datos,solicitudId:solicitudGuardado.current.id},db,uidEfectivo);
    solicitudGuardado.current=null;return resultado;
  };

  const guardarReservaSoloReservar = async () => {
    if (!zonaActiva || guardandoReserva) return false;
    setError(''); setGuardandoReserva(true);
    try {
      const { reserva } = await crearReservaFirestore({ estado: ESTADOS.RESERVADA });
      aplicarReservaEnMapa(false, '', reserva); setRevisionMapa(n=>n+1); cerrarWizard(); return true;
    } catch (e) { setError(e.message); return false; }
    finally { setGuardandoReserva(false); }
  };

  const guardarReservaPrepago = async () => {
    if (!zonaActiva || guardandoReserva) return false;
    if (!form.paqueteId) { setError('Selecciona un paquete válido.'); return false; }
    setError(''); setGuardandoReserva(true);
    try {
      const resultado = await crearReservaFirestore({ estado: ESTADOS.PREPAGADA });
      aplicarReservaEnMapa(true, form.paqueteId, resultado.reserva);
      setEntrega(resultado); setRevisionMapa(n=>n+1); cerrarWizard(); setCarritoEntradas({}); return true;
    } catch (e) { setError(e.message); return false; }
    finally { setGuardandoReserva(false); }
  };

  const cerrarEntrega = () => { if (!compartiendoEntradas) setEntrega(null); };

  const handleGenerarZipEntradas = async (files) => {
    if (!entrega?.items?.length || compartiendoEntradas) return;
    if (!Array.isArray(files) || files.length !== entrega.items.length) return;
    setCompartiendoEntradas(true);
    try {
      const zip = new JSZip();
      files.forEach(file => zip.file(file.name, file));
      const blob = await zip.generateAsync({ type: 'blob' });
      const safeName = (entrega.comprador || '').trim().replace(/\s+/g, '_').toLowerCase();
      saveAs(blob, `entradas-${safeName || 'comprador'}.zip`);
    } catch (e) {
      console.error('Error generando ZIP de entradas', e);
      alert('Error generando ZIP.');
    } finally { setCompartiendoEntradas(false); }
  };

  const handleEnviarWhatsappEntradas = async (files) => {
    if (!entrega?.items?.length || compartiendoEntradas) return;
    setCompartiendoEntradas(true);
    try {
      const resultado = await compartirArchivosEntradasReserva(files);
      if (resultado === 'zip') alert('Tu navegador no permite enviar varias imágenes. Se descargó un ZIP con todas.');
    } catch (e) {
      console.error('Error compartiendo entradas de reserva', e);
      alert(`No se pudieron entregar las entradas: ${e.message}`);
    } finally { setCompartiendoEntradas(false); }
  };

  const abrirWizard = (zona) => {
    if(!zona.reserva&&!zona.reservaPublica&&!permiteRol(perfilEfectivo,'reservas.crear')){setError('Tu rol solo puede consultar reservas.');return;}
    if(zona.reservaPublica&&!permiteRol(perfilEfectivo,'reservas.prepagar')){setError('No tienes permiso para prepagar reservas.');return;}
    if (!disponibilidadLista || zona.bloqueada) { setError('Esta zona no está disponible para tu usuario.'); return; }
    if (zona.reserva) {
      if(!puedeOperarReserva(perfilEfectivo,uidEfectivo,zona.reserva)){setError('Solo puedes gestionar tus propias reservas.');return;}
      setGestion(zona); return;
    }
    if(zona.reservaPublica?.id) {
      setZonaActiva(zona); setError('');setCarritoEntradas({});
      setForm(f=>({...f,nombreCliente:'Reserva de otro usuario',atribuidoAUid:'',atribuidoANombre:'',paqueteId:''}));
      setModalCompraOpen(true);return;
    }
    setZonaActiva(zona);
    setWizardOpen(true);
    setPaso(1);
    setError('');

    const atribucionInicialUid = puedeElegirRelacionador
      ? zona.atribuidoAUid || atribucionPropiaUid || ''
      : zona.atribuidoAUid || uidEfectivo || '';

    const atribucionInicialNombre = puedeElegirRelacionador
      ? zona.atribuidoANombre || atribucionPropiaNombre || nombreUsuario || ''
      : nombreUsuario || zona.atribuidoANombre || '';

    setForm({
      nombreCliente: zona.nombreCliente || '',
      atribuidoAUid: atribucionInicialUid,
      atribuidoANombre: atribucionInicialNombre,
      quierePrepagar: false,
      paqueteId: '',
    });

    // ✅ por seguridad, al abrir wizard reseteamos carrito
    setCarritoEntradas({});
  };

  const [reservaAbiertaPorUrl, setReservaAbiertaPorUrl] = useState('');
  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get('reserva');
    const zona = zonas.find((z) => z.reserva?.id === id);
    if (id && zona && rolEfectivo && reservaAbiertaPorUrl !== id) { setReservaAbiertaPorUrl(id); abrirWizard(zona); }
    // El intento de apertura depende de la reserva recibida y del rol verificado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zonas, rolEfectivo, reservaAbiertaPorUrl]);

  const back = () => {
    setError('');
    setPaso((p) => Math.max(1, p - 1));
  };

  const next = () => {
    setError('');

    if (paso === 2) {
      if (!tieneNombreApellido(form.nombreCliente)) {
        setError('Ingresa nombre y apellido (mínimo 2 palabras).');
        return;
      }
    }

    setPaso((p) => Math.min(3, p + 1));
  };

  return (
    <div className="reservas-page">
      <h1 className="reservas-title">Mapa de Mesas y Lounges</h1>

      {eventoActual && (
        <div style={{ marginTop: 8, marginBottom: 14, fontSize: 14, fontWeight: 700, color: '#e5e7eb' }}>
          {(eventoActual?.nombre || eventoActual?.titulo || '').trim()}
          {eventoActual?.fechaTexto ? ` (${eventoActual.fechaTexto})` : ''}
        </div>
      )}

      {error && !wizardOpen && !modalCompraOpen && <div role="alert" className="reb-warning">{error}</div>}
      <p className="reb-operation-help">{rolEfectivo === 'owner' ? 'Gestión global: selecciona una reserva para administrarla o recuperar sus entradas.' : 'Puedes gestionar tus reservas y prepagar zonas reservadas por otros usuarios. Confirmar ese prepago te convierte en propietario; las prepagadas ajenas permanecen privadas.'}</p>
      {errorPaquetes && <div className="reb-warning">{errorPaquetes}</div>}

      <MapaReservaInteractivo key={eventoId} cargando={!disponibilidadLista||mapaCargadoPara!==contextoCargaMapa} errorCarga={errorMapa} plano={planoRecinto} zonas={zonas} onZonaClick={abrirWizard} paused={wizardOpen||modalCompraOpen||!!gestion||!!entrega||generandoEntrega||guardandoReserva} disabled={!disponibilidadLista || !!gestion || modalCompraOpen || generandoEntrega || guardandoReserva} fallback2d={
      <MapaReservas
        zonas={zonas}
        mapScale={mapScale}
        baseWidth={MAP_BASE_WIDTH}
        baseHeight={MAP_BASE_HEIGHT}
        offsetX={OFFSET_X}
        offsetY={OFFSET_Y}
        esLounge={esLounge}
        numeroVisible={numeroVisible}
        colorPorEstado={colorPorEstado}
        onZonaClick={abrirWizard}
        disabled={!disponibilidadLista || !!gestion || modalCompraOpen || generandoEntrega || guardandoReserva}
        disabledTitle={
          modalCompraOpen
            ? 'Cierra la ventana de compra para continuar.'
            : guardandoReserva
            ? 'Guardando reserva…'
            : ''
        }
      />
      }/>

      {gestion && <GestionReserva contextoRecinto={contextoRecinto} plano={planoRecinto} zona={gestion} zonas={zonas} mapConfig={{baseWidth:MAP_BASE_WIDTH,baseHeight:MAP_BASE_HEIGHT,offsetX:OFFSET_X,offsetY:OFFSET_Y,esLounge,numeroVisible,colorPorEstado}} owner={rolEfectivo==='owner'} combos={combosEntradas} relacionadores={listaReservadores} titulares={titularesOperativos} paquetes={catalogoVenta.paquetes}
        onClose={()=>setGestion(null)}
        onPrepagar={()=>{setZonaActiva(gestion);setForm(f=>({...f,nombreCliente:gestion.reserva.nombreCliente,paqueteId:''}));setCarritoEntradas({});setGestion(null);setModalCompraOpen(true);}}
        onVerEntradas={()=>{cargarEntregaReserva(gestion.reserva).then(e=>{setGestion(null);setEntrega(e);}).catch(e=>setError(e.message));}}
        onCompleta={async(result,accion)=>{setGestion(null);setRevisionMapa(n=>n+1);if(accion==='adicionales'){try{setEntrega(await cargarEntregaReserva({id:result.reservaId}));}catch(e){setError('La compra quedó confirmada. No vuelvas a cobrar: abre la reserva y selecciona Ver y entregar entradas para recuperarlas. '+e.message);}}}}
      />}
      <WizardReserva
        open={wizardOpen && !!zonaActiva}
        zonaActiva={zonaActiva}
        paso={paso}
        tituloZona={zonaActiva ? `${tipoZonaTexto(zonaActiva).toUpperCase()} ${numeroVisible(zonaActiva)}` : ''}
        pisoZona={pisoZonaNombre(zonaActiva)}
        tipoZonaTexto={tipoZonaTexto}
        error={error}
        form={form}
        setForm={setForm}
        esOwnerOSocio={puedeElegirRelacionador}
        listaReservadores={listaReservadores}
        nombreUsuario={nombreUsuario}
        loadingPaquetes={loadingPaquetes}
        generandoEntrega={generandoEntrega || guardandoReserva}
        onClose={() => {
          setWizardOpen(false);
          setZonaActiva(null);
          setPaso(1);
          setError('');
          setCarritoEntradas({});
        }}
        onBack={back}
        onNext={next}
        onNoPrepago={guardarReservaSoloReservar}
        onSiPrepago={() => {
          setError('');
          setForm((f) => ({ ...f, quierePrepagar: true, paqueteId: '' }));
          setWizardOpen(false);
          setPaso(1);
          abrirModalCompra();
        }}
      />

      <ModalPrepago
        cambiaPropietario={!!(zonaActiva?.reserva || zonaActiva?.reservaPublica)}
        open={modalCompraOpen && !!zonaActiva}
        tituloZona={zonaActiva ? `${tipoZonaTexto(zonaActiva).toUpperCase()} ${numeroVisible(zonaActiva)}` : ''}
        pisoZona={pisoZonaNombre(zonaActiva)}
        eventoActual={eventoActual}
        error={error}
        form={form}
        setForm={setForm}
        loadingPaquetes={loadingPaquetes}
        opcionesPago={opcionesPago}
        generandoEntrega={generandoEntrega || guardandoReserva}
        onClose={cerrarModalCompra}
        onComprar={async () => {
          const ok = await guardarReservaPrepago();
          if (ok) setModalCompraOpen(false);
        }}
        combosEntradas={combosEntradas}
        carrito={carritoEntradas}
        setCarrito={setCarritoEntradas}
        totalExtras={totalExtras}
        totalGeneral={totalGeneral}
      />

      <ModalEntrega
        entrega={entrega}
        onClose={cerrarEntrega}
        onEnviarWhatsapp={handleEnviarWhatsappEntradas}
        compartiendo={compartiendoEntradas}
        onDescargarZip={handleGenerarZipEntradas}
      />
    </div>
  );
}

export default Reservas;
